(function () {
  var hero = document.querySelector('[data-skn-fixed-hero]');
  if (!hero) return;

  var bg = hero.querySelector('[data-skn-fixed-hero-bg]');
  var logo = hero.querySelector('.skn-fixed-hero__logo');
  var parallaxEnd = document.querySelector('[data-skn-parallax-end]');

  function fitLogo() {
    if (!logo) return;

    var target = window.innerWidth * 0.9;
    var current = parseFloat(window.getComputedStyle(logo).fontSize) || 80;
    var width = logo.scrollWidth;

    if (width > 0) {
      logo.style.fontSize = (current * target) / width + 'px';
    }
  }

  function updateBg() {
    if (!bg) return;

    var ingredients = document.querySelector('[data-skn-ingredient-theatre]');
    if (ingredients) {
      var ingRect = ingredients.getBoundingClientRect();
      if (ingRect.top <= 0 && ingRect.bottom > 0) {
        bg.style.visibility = 'hidden';
        return;
      }
    }

    var plainFacts = document.querySelector('[data-skn-plain-facts]');
    if (plainFacts) {
      var pfRect = plainFacts.getBoundingClientRect();
      if (pfRect.top <= 0 && pfRect.bottom > 0) {
        bg.style.visibility = 'hidden';
        return;
      }
    }

    var heroBottom = hero.getBoundingClientRect().bottom;
    var endBottom = parallaxEnd
      ? parallaxEnd.getBoundingClientRect().bottom
      : heroBottom;

    bg.style.visibility = Math.max(heroBottom, endBottom) <= 0 ? 'hidden' : 'visible';
  }

  var reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReduced() {
    return reducedMq.matches;
  }

  /* Play the fade when the hero is on screen. Reset it once the hero has
     scrolled away, so coming back plays the same animation again. */
  function syncLogo() {
    if (!logo) return;

    if (prefersReduced()) {
      logo.classList.add('is-ready');
      return;
    }

    var rect = logo.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var onScreen = rect.bottom > vh * 0.18 && rect.top < vh * 0.82;
    var gone = rect.bottom < vh * 0.04 || rect.top > vh;

    if (gone) {
      logo.classList.remove('is-ready');
      return;
    }

    if (onScreen && !logo.classList.contains('is-ready')) {
      fitLogo();
      void logo.offsetWidth;
      logo.classList.add('is-ready');
    }
  }

  function update() {
    fitLogo();
    updateBg();
    syncLogo();
  }

  window.addEventListener('scroll', function () {
    updateBg();
    syncLogo();
  }, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('pageshow', syncLogo);
  window.addEventListener('hashchange', syncLogo);
  document.addEventListener('shopify:section:load', update);

  if (reducedMq.addEventListener) {
    reducedMq.addEventListener('change', syncLogo);
  } else if (reducedMq.addListener) {
    reducedMq.addListener(syncLogo);
  }

  update();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncLogo);
  }

  window.setTimeout(syncLogo, 400);
})();
